import { Button } from "@components/Button";
import { Dialog, DialogContent } from "@components/Dialog";
import { Typography } from "@components/Typography";

import { tourDCStorage } from "@storage/localStorage";

interface FinishTourDialogProps {
	onClose: () => void;
}

export const FinishTourDialog = ({ onClose }: FinishTourDialogProps) => {
	const handleFinish = () => {
		tourDCStorage.setItem("off");
		onClose();
	};

	return (
		<Dialog open onOpenChange={(open) => !open && handleFinish()}>
			<DialogContent className="max-w-[371px] border border-white" showCloseButton={false}>
				<div className="px-[23px] py-4">
					<Typography type="p" size="xl" weight="bold">
						Congratulations!
					</Typography>
					<div className="h-[15px]" />
					<Typography type="p" size="sm">
						Your Tip Menu is available for users!
					</Typography>
					<div className="h-[15px]" />
					<Button onClick={handleFinish}>
						<Typography weight="bold">Finish</Typography>
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};
